var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        _vm.type === "mobile" ? "search-mobile__wrapper" : "search__wrapper",
    },
    [
      _vm.type === "desktop"
        ? [
            _c("div", { staticClass: "search__input-wrapper" }, [
              _c("span", { staticClass: "search__input-inner" }, [
                _c("input", {
                  staticClass: "search__input",
                  attrs: {
                    type: "search",
                    title: "search desktop",
                    placeholder: _vm.$translate(
                      "ODFashioncode::Fashioncode.searchDesktopPlaceholder"
                    ),
                  },
                  on: {
                    input: function ($event) {
                      return _vm.autocomplete($event.target.value)
                    },
                    keyup: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.prepareSearch()
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "down", 40, $event.key, [
                            "Down",
                            "ArrowDown",
                          ])
                        ) {
                          return null
                        }
                        return _vm.keydown()
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "up", 38, $event.key, [
                            "Up",
                            "ArrowUp",
                          ])
                        ) {
                          return null
                        }
                        return _vm.keyup()
                      },
                    ],
                    focus: function ($event) {
                      return _vm.setIsSearchFocused(true)
                    },
                    blur: function ($event) {
                      return _vm.setIsSearchFocused(false)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "search__button",
                    on: {
                      click: function ($event) {
                        return _vm.search()
                      },
                    },
                  },
                  [
                    _c("svg", { attrs: { width: "20", height: "20" } }, [
                      _c("use", {
                        attrs: {
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "xlink:href": "#svg-search",
                        },
                      }),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "search__desktop-result-wrapper js--search__result",
              },
              [
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.autocompleteResult.length
                    ? _c("div", [
                        _c("div", { staticClass: "search__count" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$translate(
                                  "ODFashioncode::Fashioncode.searchCount"
                                )
                              ) +
                              "  (" +
                              _vm._s(_vm.total) +
                              ")\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "search__result-container" },
                          _vm._l(
                            _vm.autocompleteResult,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "search__result-wrapper",
                                  class: {
                                    "autocomplete-selected":
                                      _vm.selectedAutocompleteIndex === index,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectAutocompleteItem(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: item.url,
                                        title: item.displayName,
                                      },
                                    },
                                    [
                                      _vm.showItemImages
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "search__result-image-wrapper",
                                            },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "search__result-image",
                                                attrs: {
                                                  src: item.img,
                                                  alt: item.displayName,
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "search__result-info-wrapper",
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "search__result-name",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                item.displayName
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "search__result-price-wrapper",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "search__result-price",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(item.price.price) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              item.priceRrp &&
                                              item.priceRrp.value > 0 &&
                                              item.priceRrp.value >
                                                item.price.value
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "search__result-crossprice",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            item.priceRrp.price
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "search__show-all",
                            on: {
                              click: function ($event) {
                                return _vm.search()
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "search__show-all-inner" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "ODFashioncode::Fashioncode.searchAll"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : typeof _vm.currentSearchString !== "undefined" &&
                      _vm.currentSearchString.length >= 3 &&
                      _vm.noResult
                    ? _c("div", { staticClass: "search__no-results" }, [
                        _c("div", { staticClass: "search__no-results-inner" }, [
                          _c("svg", { attrs: { width: "135", height: "96" } }, [
                            _c("use", {
                              attrs: {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": "#svg-hanger",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "search__no-results-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "ODFashioncode::Fashioncode.searchNoResult"
                                )
                              ),
                            },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "mobile"
        ? [
            _c("div", { staticClass: "search-mobile__input-wrapper" }, [
              _c("input", {
                staticClass: "search-mobile__input",
                attrs: {
                  type: "search",
                  title: _vm.$translate(
                    "ODFashioncode::ODFashioncode.searchPlaceholder"
                  ),
                  placeholder: _vm.$translate(
                    "ODFashioncode::Fashioncode.searchPlaceholder"
                  ),
                },
                on: {
                  input: function ($event) {
                    return _vm.autocomplete($event.target.value)
                  },
                  keyup: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.prepareSearch()
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      ) {
                        return null
                      }
                      return _vm.keydown()
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      ) {
                        return null
                      }
                      return _vm.keyup()
                    },
                  ],
                  focus: function ($event) {
                    return _vm.setIsSearchFocused(true)
                  },
                  blur: function ($event) {
                    return _vm.setIsSearchFocused(false)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "search-mobile__button",
                  on: {
                    click: function ($event) {
                      return _vm.search()
                    },
                  },
                },
                [
                  _c("svg", { attrs: { width: "20", height: "20" } }, [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#svg-search",
                      },
                    }),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "search-mobile__result-wrapper js--search__result",
              },
              [
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.autocompleteResult.length
                    ? _c("div", { staticClass: "search-mobile__h-100" }, [
                        _c(
                          "div",
                          { staticClass: "search-mobile__result-inner" },
                          [
                            _c("div", { staticClass: "search__count" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "ODFashioncode::Fashioncode.searchCount"
                                    )
                                  ) +
                                  " (" +
                                  _vm._s(_vm.total) +
                                  ")\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.autocompleteResult,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "search__result-wrapper",
                                    class: {
                                      "autocomplete-selected":
                                        _vm.selectedAutocompleteIndex === index,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectAutocompleteItem(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: item.url,
                                          title: item.displayName,
                                        },
                                      },
                                      [
                                        _vm.showItemImages
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "search__result-image-wrapper",
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "search__result-image",
                                                  attrs: {
                                                    src: item.img,
                                                    alt: item.displayName,
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "search__result-info-wrapper",
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "search__result-name",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.displayName
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "search__result-price-wrapper",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "search__result-price",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          item.price.price
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                item.priceRrp &&
                                                item.priceRrp.value > 0 &&
                                                item.priceRrp.value >
                                                  item.price.value
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "search__result-crossprice",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              item.priceRrp
                                                                .price
                                                            ) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "search-mobile__show-all",
                            on: {
                              click: function ($event) {
                                return _vm.search()
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "search__show-all-inner" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "ODFashioncode::Fashioncode.searchAll"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : typeof _vm.currentSearchString !== "undefined" &&
                      _vm.currentSearchString.length >= 3 &&
                      _vm.noResult
                    ? _c("div", { staticClass: "search__no-results" }, [
                        _c("div", [
                          _c("svg", { attrs: { width: "135", height: "96" } }, [
                            _c("use", {
                              attrs: {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": "#svg-hanger",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "search__no-results-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "ODFashioncode::Fashioncode.searchNoResult"
                                )
                              ),
                            },
                          }),
                        ]),
                      ])
                    : typeof _vm.currentSearchString === "undefined" ||
                      _vm.currentSearchString.length < 3
                    ? _c("div", { staticClass: "search__search-please" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate(
                                "ODFashioncode::Fashioncode.searchPlease"
                              )
                            ) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }